const getPaymentHistory = async ({ commit, rootGetters, dispatch, state }) => {
  try {
    const customer = rootGetters["customer/CUSTOMER"];
    const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];

    let customer_id = customer.customer_id;
    if (customer.customer_id === 0) {
      customer_id = selected_customer.customer_id;
    }

    const data = {
      customer_id,
      pid: state.patient.patient_id,
    };

    const resp = await window.axios.post("/proxy/get-payment-history", data);
    if (resp && resp.data.success) {
      commit("ADD_PAYMENT_HISTORY", resp.data.paymentsList);
    } else {
      throw resp.data;
    }
  } catch (error) {
    dispatch("notifications/setError", error.message, { root: true });
  }
};

export default getPaymentHistory;
